import { render, staticRenderFns } from "./SignatureType.vue?vue&type=template&id=71513bce&"
import script from "./SignatureType.vue?vue&type=script&lang=js&"
export * from "./SignatureType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports